export default "__VITE_ASSET__96362145__"